(() => {
  const REFERRAL_API =
    "https://ultracore-referrals.ultracoresystems.workers.dev";

  const STORAGE_KEY = "uc_referral";

  async function captureReferral() {
    const params = new URLSearchParams(window.location.search);
    const referralCode = params.get("ref");

    // Check if we already have a valid referral
    const existing = getStoredReferral();

    if (existing) {
      await attachReferralToCart(existing);
      return;
    }

    if (!referralCode) return;

    const code = referralCode.trim().toUpperCase();

    if (
      !/^[A-Z0-9][A-Z0-9-]{1,18}[A-Z0-9]$/.test(code)
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${REFERRAL_API}/referral/click`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            referral_code: code,
          }),
        }
      );

      if (!response.ok) return;

      const data = await response.json();

      if (!data.success || !data.click_token) {
        return;
      }

      const referral = {
        referral_code: code,
        click_token: data.click_token,
        expires_at: data.expires_at,
      };

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(referral)
      );

      const maxAge = 30 * 24 * 60 * 60;

      document.cookie =
        `uc_referral_click=${encodeURIComponent(data.click_token)}; ` +
        `Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;

      await attachReferralToCart(referral);

    } catch (error) {
      console.error(
        "Referral tracking error:",
        error
      );
    }
  }

  function getStoredReferral() {
    try {
      const referral = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );

      if (
        !referral?.click_token ||
        !referral?.expires_at
      ) {
        return null;
      }

      if (Date.now() >= referral.expires_at) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return referral;

    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  async function attachReferralToCart(referral) {
    if (!referral?.click_token) return;

    try {
      const root =
        window.Shopify?.routes?.root || "/";

      const response = await fetch(
        `${root}cart/update.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              "_uc_referral_click":
                referral.click_token,
            },
          }),
        }
      );

      if (!response.ok) {
        console.error(
          "Unable to attach referral to cart"
        );
      }

    } catch (error) {
      console.error(
        "Referral cart error:",
        error
      );
    }
  }

  captureReferral();
})();